import { FC } from 'react'

type MapSquareIconProps = {
  size?: number
  color?: string
  style?: React.CSSProperties
}
export const MapSquareIcon: FC<MapSquareIconProps> = ({ size = 12, color = 'currentColor', style }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
      <path
        d="M11.9012 1.39003C11.9012 0.622339 11.2789 0 10.5112 0H1.47597C0.708277 0 0.0859375 0.62234 0.0859375 1.39003V5.91389H6.31961L7.64401 2.96031H11.9012V1.39003Z"
        fill={color}
      />
      <path
        d="M11.9012 3.94492H8.28157L4.75246 11.8153H10.5112C11.2789 11.8153 11.9012 11.193 11.9012 10.4253V3.94492Z"
        fill={color}
      />
      <path
        d="M3.67339 11.8153L5.87811 6.8985H0.0859375V10.4253C0.0859375 11.1929 0.708277 11.8153 1.47597 11.8153H3.67339Z"
        fill={color}
      />
    </svg>
  )
}
